/* eslint-disable camelcase */
/** @module Auth0IdentityProviderWoot */
/* eslint-disable import/extensions */
import Auth0IdentityProvider from './auth0-identity-provider.mjs';

/**
 * @constructor
 * @description A Woot-specific implementation of Auth0IdentityProvider
 *
 * Woot is a standard OIDC enterprise connection. This class extends the base
 * Auth0IdentityProvider to add any Woot-specific customizations if needed.
 *
 * Since woot-oauth2 is marked as isCustomAuth0Provider: true, it will only
 * appear in SSO button lists when explicitly allowed via:
 * - User's app_metadata.visible_idp_ids includes 'woot-oauth2'
 * - User's app_metadata.auth_method is 'auto-sso' with auto_sso_idp_id: 'woot-oauth2'
 * - Or when activeIdps list explicitly includes 'woot-oauth2'
 */
class Auth0IdentityProviderWoot extends Auth0IdentityProvider {
  /**
   * @inheritdoc
   * @description Override if Woot requires custom profile field mapping
   */
  selectName(oauthUserProfile) {
    // Woot OIDC provides standard 'name' claim
    const { name } = oauthUserProfile;
    if (name) return name;

    return super.selectName(oauthUserProfile);
  }

  /**
   * @inheritdoc
   * @description Override if Woot requires custom email field mapping
   */
  selectEmail(oauthUserProfile) {
    // Woot OIDC provides standard 'email' claim
    const { email } = oauthUserProfile;
    if (email) return email;

    return super.selectEmail(oauthUserProfile);
  }

  /**
   * @inheritdoc
   * @description Override if Woot requires custom given name field mapping
   */
  selectGivenName(oauthUserProfile) {
    // Woot OIDC may provide standard 'given_name' claim
    const { given_name } = oauthUserProfile;
    if (given_name) return given_name;

    return super.selectGivenName(oauthUserProfile);
  }

  /**
   * @inheritdoc
   * @description Override if Woot requires custom family name field mapping
   */
  selectFamilyName(oauthUserProfile) {
    // Woot OIDC may provide standard 'family_name' claim
    const { family_name } = oauthUserProfile;
    if (family_name) return family_name;

    return super.selectFamilyName(oauthUserProfile);
  }
}

export default Auth0IdentityProviderWoot;
